var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKickout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kickout",
    transform: "translate(1.000000, -2.000000)",
    fill: "#006F44",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.40918281,2.37394786 L8.70469007,3.08365905 L11.556289,5.91429041 C11.7512484,6.10781628 12.0658224,6.10781628 12.2607818,5.91429041 L15.2644181,2.93273971 L14.5599253,2.22302851 L11.9085354,4.85492289 L9.40918281,2.37394786 Z",
    id: "Path-4",
    transform: "translate(11.984554, 4.141232) scale(-1, 1) rotate(135.000000) translate(-11.984554, -4.141232) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    transform: "translate(10.173288, 5.879568) scale(-1, 1) rotate(135.000000) translate(-10.173288, -5.879568) ",
    points: "9.70464868 2.06351268 9.64196038 9.68740092 10.6419266 9.69562326 10.7046149 2.07173502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,10.0723618 L12.5,15.6474351 L0.5,15.6474351 L0.5,3.64743507 L5.82677231,3.64743507 L5.82677231,2.64743507 L0,2.64743507 C-0.276142375,2.64743507 -0.5,2.8712927 -0.5,3.14743507 L-0.5,16.1474351 C-0.5,16.4235774 -0.276142375,16.6474351 0,16.6474351 L13,16.6474351 C13.2761424,16.6474351 13.5,16.4235774 13.5,16.1474351 L13.5,10.0723618 L12.5,10.0723618 Z",
    id: "Path-9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickout);
export default __webpack_public_path__ + "static/media/kickout.163ae7e98c89579036b92b229c64a549.svg";
export { ForwardRef as ReactComponent };